import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
} from '@angular/core';
import { CaseBattlesService } from '../case-battles.service';
import { GameIconComponent } from '../../../core/components/game-icon/game-icon.component';
import { CbListItemComponent } from '../cb-list-item/cb-list-item.component';
import { RouterLink } from '@angular/router';
import { CostComponent } from '../../../core/components/cost/cost.component';
import { SelectComponent } from '../../../core/components/select/select.component';
import { FairnessButtonComponent } from '../../../core/components/fairness-button/fairness-button.component';
import { UIService } from '@core/services/ui.service';

enum SortOptions {
  highest_price,
  lowest_price,
}

interface SortOption {
  label: string;
  key: keyof typeof SortOptions;
  fn: () => void;
}

@Component({
  selector: 'app-cb-list',
  templateUrl: './cb-list.component.html',
  styleUrls: ['./cb-list.component.scss'],
  standalone: true,
  imports: [
    GameIconComponent,
    CbListItemComponent,
    RouterLink,
    CostComponent,
    SelectComponent,
    FairnessButtonComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CbListComponent {
  public readonly cbService = inject(CaseBattlesService);
  public readonly uiService = inject(UIService);

  readonly sortOptions: SortOption[] = [
    {
      label: 'Highest Price',
      key: 'highest_price',
      fn: () => {
        this.sort.set(this.sortOptions[0]);
        this.cbService.displaySort.set('DESC');
      },
    },
    {
      label: 'Lowest Price',
      key: 'lowest_price',
      fn: () => {
        this.sort.set(this.sortOptions[1]);
        this.cbService.displaySort.set('ASC');
      },
    },
  ];
  readonly sort = signal<SortOption>(this.sortOptions[0]);

  constructor() {}
}
